import React, { useState, forwardRef, useImperativeHandle } from 'react'
import { getTheme } from 'helpers'

// Components
import styled from 'styled-components'
import theme from 'theme'
import { Select, Input } from 'antd'
import FormGroup from 'components/FormGroup'
import Label from 'components/Label'

// Hooks
import { useCourseOptions } from 'hooks/custom'

export default forwardRef(({ courseCode, title = '', description = '' }, ref) => {
  const [scourseCode, setcourseCode] = useState(courseCode)
  const [sTitle, setTitle] = useState(title)

  const [titleError, setTitleError] = useState()
  const [courseCodeError, setcourseCodeError] = useState()
  const { options: courseOptions, loading: optionsLoading } = useCourseOptions()

  useImperativeHandle(ref, () => ({
    getFormData: () => {
      const _courseCodeError = !scourseCode && 'กรุณาเลือกคอร์สเรียน'
      const _titleError = !sTitle && 'กรุณากรอกชื่อแบบทดสอบ'

      setcourseCodeError(_courseCodeError)
      setTitleError(_titleError)
      return [_courseCodeError, _titleError].some(error => error) ? false : {
        title: sTitle,
        courseCode: scourseCode
      }
    }
  }))

  return (
    <div>
      <FormGroup>
        <Label required>ชื่อแบบทดสอบ</Label>
        <Input
          style={{ borderColor: titleError ? theme.colors.red : null }}
          value={sTitle}
          onChange={e => setTitle(e.target.value)} />
        {titleError && <ErrorText>{titleError}</ErrorText>}
      </FormGroup>
      <FormGroup>
        <Label required>คอร์สเรียน</Label>
        <SelectWrapper>
          <Select
            className={titleError ? 'hasError' : ''}
            disabled={optionsLoading}
            loading={optionsLoading}
            style={{ width: '100%' }}
            placeholder='เลือกคอร์สเรียน'
            value={scourseCode}
            onChange={_courseCode => setcourseCode(_courseCode)}>
            {courseOptions.map(({ label, value }) => <Select.Option key={value} value={value}>{value}: {label}</Select.Option>)}
          </Select>
        </SelectWrapper>
        {courseCodeError && <ErrorText>{courseCodeError}</ErrorText>}
      </FormGroup>
    </div>
  )
})

const SelectWrapper = styled.div`
  > .hasError > .ant-select-selection {
    border-color: ${getTheme`colors.red`} !important;
  }
`
const ErrorText = styled.div`
  margin-top: 5px;
  font-size: 12px;
  color: ${getTheme`colors.red`};
`



// WEBPACK FOOTER //
// ./src/components/exams/ExamForm.js